import { useWindowSize } from 'src/modules/store/windowSizeStore';

export const useGetGameNameFontSize = (gameName: string) => {
  const { is768 } = useWindowSize('is768');

  const defaultSize = is768 ? 12 : 11;
  const maxWordLength = is768 ? 11 : 10.5;

  if (!gameName) return defaultSize;

  const gameNameFirstWordLength = String(gameName?.split(' ')[0]).length;

  const fontSizeCoefficient =
    gameNameFirstWordLength > maxWordLength ? maxWordLength / gameNameFirstWordLength : 1;

  return defaultSize * fontSizeCoefficient;
};
